// Winners & Nominees year page — bg-jnote vertical anchor.
//
// The decorative .bg-jnote is position:absolute inside <main>, which is
// position:relative. We want the TOP edge of the J-note to sit at the
// vertical centre of the "WINNERS" headline (.wn-winners-block
// .wn-headline) so it reads as drifting in from behind that title.
//
// Hardcoded `top` values in CSS drift across breakpoints because the
// headline's actual Y depends on header height, subnav height, intro
// row height, etc. — none of which are constants. Measuring at runtime
// keeps the anchor correct no matter what's above the headline.
//
// Re-runs on resize (debounced) and once images/fonts settle.

const SELECTOR_NOTE     = '.page-winners-nominees .bg-jnote'
const SELECTOR_HEADLINE = '.wn-winners-block .wn-headline'

function position(note, headline) {
    // The note's offsetParent is its nearest positioned ancestor
    // (<main class="main-content"> per pageDeco.scss), which is the
    // coordinate system its `top` value resolves against.
    const offsetParent = note.offsetParent
    if (!offsetParent) return

    const headlineRect = headline.getBoundingClientRect()
    const parentRect   = offsetParent.getBoundingClientRect()
    if (headlineRect.height <= 0) return

    // Top of the note = vertical centre of the headline, in the
    // offsetParent's coordinate space.
    const target = Math.round(
        (headlineRect.top + headlineRect.height / 2) - parentRect.top
    )
    note.style.top = `${target}px`
}

const wnJnotePosition = {
    init() {
        const note     = document.querySelector(SELECTOR_NOTE)
        const headline = document.querySelector(SELECTOR_HEADLINE)
        if (!note || !headline) return

        const run = () => position(note, headline)

        // Run once now and again after a frame so layout has settled.
        run()
        window.requestAnimationFrame(run)

        // Debounced resize so a drag-resize doesn't trigger a flurry
        // of partial recomputes mid-layout.
        let resizeTimer
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(run, 150)
        })

        // Fonts can shift the headline's height once they swap in.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(run).catch(() => {})
        }
    },
}

export default wnJnotePosition
